var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-parent" }, [
    _c("div", { staticClass: "chartdiv", attrs: { id: "table_div" } }, [
      _c("span", [
        _vm._v(
          _vm._s(_vm.tableData.data.length) + " " + _vm._s(_vm.tableData.name)
        )
      ]),
      _vm._v(" "),
      _c("table", [
        _c(
          "tbody",
          _vm._l(_vm.tableData.data, function(item, index) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(item.id))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.description))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(item.status))])
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "chart-legend" }, [
      _c("span", [_vm._v(_vm._s(_vm.name))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }